import React from 'react'

const AvatarIcon = props => (
  <svg viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      opacity="0.4"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 5.5C0 2.46243 2.46243 0 5.5 0C8.525 0 11 2.4585 11 5.5C11 6.95869 10.4205 8.35764 9.38909 9.38909C8.35764 10.4205 6.95869 11 5.5 11C4.04131 11 2.64236 10.4205 1.61091 9.38909C0.579463 8.35764 0 6.95869 0 5.5ZM5.5 1.65C6.41127 1.65 7.15 2.38873 7.15 3.3C7.15 4.21127 6.41127 4.95 5.5 4.95C4.58873 4.95 3.85 4.21127 3.85 3.3C3.85 2.38873 4.58873 1.65 5.5 1.65ZM5.5 9.46C4.125 9.46 2.9095 8.756 2.2 7.7C2.2165 6.6 4.4 5.995 5.5 5.995C6.6 5.995 8.7835 6.6 8.8 7.7C8.0905 8.756 6.875 9.46 5.5 9.46Z"
      fill="white"
    />
  </svg>
)

export default AvatarIcon
